export function selectInputText(input: HTMLInputElement | HTMLTextAreaElement): void {
  try {
    input.select();
  } catch {
    // Some input types do not expose text selection APIs.
  }
}

export function queueSelectInputText(input: HTMLInputElement | HTMLTextAreaElement): void {
  selectInputText(input);
  requestAnimationFrame(() => {
    selectInputText(input);
  });
}
